// /login and /login?returnTo=<path> (FR-013 to FR-017; routes.md).
import { LoginScreen } from "@/auth/email/LoginScreen";

export default function Login() {
  return <LoginScreen />;
}
